<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';
import AccordionComponent from '@/components/AccordionComponent.vue';

const questions = [
  {
    q: 'Notar þú skjátæki til að róa þig?',
    a: 'T.d. með því að horfa á þætti eða stutt myndbönd á samfélagsmiðlum fyrir svefninn?',
  },
  {
    q: 'Ertu háð/ur?',
    a: [
      'Hvað myndir þú gera yfir heilan dag, þar sem þú hefðir hvorki aðgang að skjátæki eða nettengingu?',
      'Hversu lengi gætir þú verið án nettengingar?',
    ],
  },
  {
    q: 'Hvað gæti komið í staðinn fyrir tímann sem þú eyðir í heilalaust skrun í símanum?',
    a: [
      'Fara í sund, hanga með vinum, fara í bíó, út í fótbolta/körfubolta/leiki, lesa bók, hlusta á hlaðvarp eða sögu?',
      'Eða velja eitthvað gagnlegra í símanum? Myndbönd sem kenna okkur eitthvað — eða gagnleg, fræðandi eða skapandi öpp?',
    ],
  },
  {
    q: 'Er eitthvað sem þú notar í símanum sem væri hægt að skipta út?',
    a: 'T.d. „gamaldags“ alvöru vekjaraklukka, reiknivél, dagatal, myndavél eða lesbretti?',
  },
  {
    q: 'Ertu að missa af?',
    a: [
      'Ertu of mikið að fylgjast með því sem aðrir eru að gera annarsstaðar í stað þess að fylgjast með því sem er að gerast á staðnum? T.d. skemmtilegum samræðum eða sögu sem er verið að segja?',
      'Er samanburður við aðra að skemma upplifun okkar af því sem við gerum sjálf?',
    ],
  },
  {
    q: 'Ekki láta mata þig',
    a: 'Heilinn er hannaður til að hugsa - ekki til að láta aðeins mata sig á upplýsingum. Það er gott að gefa sér frí frá áreiti reglulega yfir daginn til að vinna úr og festa í minni þær upplýsingar sem við meðtökum.',
  },
  {
    q: 'Finnst þér stundum eins og síminn þinn sé að hlusta á þig?',
    a: 'Prófaðu að breyta gagnasöfnunarstillingunum í símanum þínum.',
  },
];
</script>

<template>
  <BoundedComponent is="section">
    <h2 v-fade-up class="mb-4">Fleiri atriði til umhugsunar</h2>
    <AccordionComponent :questions="questions" version="2" />
    <div v-fade-up class="text-white text-center font-bold text-sm mt-10 md:text-lg">
      Hvert finnst þér að aldurstakmark samfélagsmiðla ætti að vera?
    </div>
  </BoundedComponent>
</template>
